import { getFileBase64 } from "./getFileBase64";

export const getFilePreview = async (file: File): Promise<string> => {
  if (file.type.startsWith("video/")) {
    // 使用 blob URL 避免巨大的 base64 字符串阻塞 DOM
    return URL.createObjectURL(file);
  }
  const base64 = await getFileBase64(file);
  return base64;
};
